






















// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, PropType, onMounted, ref, computed } from '@vue/composition-api';
// Import utils ------------------------------------------------------------------------------------

// Import types ------------------------------------------------------------------------------------
import type { EResultsTab } from '@/components/patient/results/PatientResults.vue';
import { EFilter } from '@/components/patient/results/PatientResultsHeader.vue';
import { AnalysisEntityCompleted } from '@/plugins/podocore/repositories/analysis.repository';
// Import components -------------------------------------------------------------------------------
import PatientResultsErroneous from './PatientResultsErroneous.vue';
import PatientResultsWalkingDegraded from './PatientResultsWalkingDegraded.vue';
import PatientResultsWalkingGeneral from './PatientResultsWalkingGeneral.vue';
import PatientResultsWalkingAdvanced from './PatientResultsWalkingAdvanced.vue';
// import PatientResultsWalkingPathology from './PatientResultsWalkingPathology.vue';
// import PatientResultsWalkingCustom from './PatientResultsWalkingCustom.vue';

interface AnalysisDetails {
  cuid: string;
  subscriptionId: string;
}

export default defineComponent({
  name: 'PatientResultsWalking',
  components: {
    PatientResultsErroneous,
    PatientResultsWalkingDegraded,
    PatientResultsWalkingGeneral,
    PatientResultsWalkingAdvanced
    // PatientResultsWalkingPathology,
    // PatientResultsWalkingCustom,
  },
  props: {
    analysis: {
      type: Object as PropType<AnalysisEntityCompleted>,
      required: true
    },
    aggregates: {
      type: Object,
      required: true
    },
    norms: {
      type: Object,
      required: true
    },
    displayMetrics: {
      type: Object,
      required: true
    },
    resultsTab: {
      type: String as PropType<EResultsTab>,
      required: true
    },
    selectedFilter: {
      type: String as PropType<EFilter>,
      required: true
    },
    degradedAnalysis: {
      type: Boolean
    },
    validAnalysis: {
      type: Boolean
    },
    customSelectedCharts: {
      type: Array,
      required: false
    }
  },
  setup(properties) {
    const hasInjuryRehab = computed(
      () => properties.analysis.subscriptionId === 'injury_rehabilitation_movement_screening'
    );
    const hasSportsMedicine = computed(
      () => properties.analysis.subscriptionId === 'sports_medicine_return_to_play'
    );
    const hasNeurologicalElderlyMobilityMonitoring = computed(
      () => properties.analysis.subscriptionId === 'neurological_elderly_mobility_monitoring'
    );

    return {
      hasInjuryRehab,
      hasSportsMedicine,
      hasNeurologicalElderlyMobilityMonitoring
    };
  }
});
